import '../design-system/ds-runtime.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Provider } from '@/components/ui/provider';
import { AuthProvider } from '@/lib/hooks/use-auth';
import App from './app';
import './styles/animations.css';

Sentry.init({
  dsn: 'https://293c3e4e22e12616d2854784de8825e3@o4508869590712320.ingest.us.sentry.io/4508869591957504',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/connect\.athleteera\.app/,
    /^https:\/\/d3b9alri0eiqg0\.cloudfront\.net/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <Provider>
        <App />
      </Provider>
    </AuthProvider>
  </React.StrictMode>,
);
